module.exports = require('react/lib/ReactFragment').create;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-addons-create-fragment/index.js
// module id = 1019
// module chunks = 0